import useLocale from "hooks/useLocale";

const useLocalizedData = (...data) => {
    const locale = useLocale();
    return data.map(it => it[locale]);
}
export default useLocalizedData;